import { render, staticRenderFns } from "./personality-page.vue?vue&type=template&id=8c905b20&scoped=true&"
import script from "./personality-page.vue?vue&type=script&lang=js&"
export * from "./personality-page.vue?vue&type=script&lang=js&"
import style0 from "./personality-page.vue?vue&type=style&index=0&id=8c905b20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c905b20",
  null
  
)

export default component.exports